/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col} from "react-bootstrap";


type TerminalsListLegendProps = {
    TERMINALS_LIST_TYPE?: "TERMINALS" | "FAVORITE_TERMINALS" | "DISPOSITIONS" | "MONITORY_NOTES";
};


export const TerminalsListLegendComponent: React.FC<TerminalsListLegendProps> = ({
    TERMINALS_LIST_TYPE = "TERMINALS"
}): JSX.Element | null => {


    return (
        <Col xs={12} className={"terminals-list-legend-component terminals-list-legend"}>

            {TERMINALS_LIST_TYPE === "TERMINALS" &&
	        <Col xs={12} className={"terminals-list-legend-item"}>
		        <span className={"legend-item-icon waiting-for-submit-transports-information"}></span>
		        <span className={"legend-item-label"}>{`Liczba transp. oczekujących na przedłożenie`}</span>
	        </Col>
            }

            {TERMINALS_LIST_TYPE === "TERMINALS" &&
	        <Col xs={12} className={"terminals-list-legend-item"}>
		        <span className={"legend-item-icon waiting-for-entry-transports-information"}></span>
		        <span className={"legend-item-label"}>{`Liczba transp. oczekujących na wjazd`}</span>
	        </Col>
            }

            {TERMINALS_LIST_TYPE === "TERMINALS" &&
	        <Col xs={12} className={"terminals-list-legend-item"}>
		        <span className={"legend-item-icon active-transports-information"}></span>
		        <span className={"legend-item-label"}>{`Liczba transp. w trakcie załadunku`}</span>
	        </Col>
            }

            <Col xs={12} className={"terminals-list-legend-item"}>
                <span className={"legend-item-icon my-dispositions-information"}></span>
                <span className={"legend-item-label"}>{`Liczba moich dyspozycji`}</span>
            </Col>

            <Col xs={12} className={"terminals-list-legend-item"}>
                <span className={"legend-item-icon my-monitory-notes-information"}></span>
                <span className={"legend-item-label"}>{`Liczba moich awizacji`}</span>
            </Col>

        </Col>
    );

};


export default TerminalsListLegendComponent;
